import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export interface ExportDTBPackageResponse {
  jobId?: string;
  presignedUrl?: string;
  base64?: string;
  fileType?: 'PDF' | 'DOCX';
}

export const getExportDTBPackage = async(
  orgId: string,
  dtbPackageId: string,
) => {
  const url = `${baseApiUrl()}/lexiverse/export/v1/organizations/${orgId}/packages/${dtbPackageId}/export`;
  const queryParams = new URLSearchParams({
    exportType: 'PDF',
  });

  const finalUrl = `${url}?${queryParams.toString()}`;

  const data = await fetcher({
    method: 'get',
    url: finalUrl,
  });

  return data;
}

export default function useExportDTBPackage() {
    const exportDTBPackage = async (
    orgId: string,
    dtbPackageId: string,
    callback?: (data: ExportDTBPackageResponse) => void,
    onError?: (errors: ServerErrorResponse) => void
    ) => {
      try {
        // getExportDTBPackage returns a react-query object, not plain data
        const data = await getExportDTBPackage(orgId, dtbPackageId);
        if (callback) await callback(data);
        return data;
      } catch (err) {
        if (onError) {
          // Handle error with callback and don't throw to prevent React error boundary
          handleError(err as Error, { onError });
          return;
        }
        // Only throw if no error handler is provided
        throw err;
      }
    };
  
    return {
        exportDTBPackage,
    };
  }
